
<template>

	<mymodal ref="modal" title="Импорт значений ценообразующих факторов" ok="Импортировать" :reset="reset" :check="check" :submit="submit" width="800px">

		<b-overlay :show="wait">

			<b-form-group :state="fl_state" label="Файл" label-for="fl_input" invalid-feedback="Необходимо указать файл">
				
				<b-form-file id="fl_input" :state="fl_state" accept=".xlsx" v-model="fl" placeholder="Файл" v-on:input="file => load_file(file)"/>

			</b-form-group>

			<b-form-group :state="sheet_state" label="Страница" label-for="sheet_select" invalid-feedback="Необходимо указать страницу">

				<v-select id="sheet_select" :state="sheet_state" :clearable="false" v-model="sheet" :options="wb.SheetNames" v-on:input="sheet_select" clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<b-form-group :state="primary_attr_state" label="Характеристика  - первичный ключ" label-for="primary_attr_select" invalid-feedback="Необходимо указать характеристику - первичный ключ">

				<v-select id="primary_attr_select" :state="primary_attr_state" :clearable="false" v-model="primary_attr" label="name" :reduce="obj => obj.id" :options="attrs_for_primary_key" disabled clearSearchOnSelect required appendToBody/>

			</b-form-group>

			<!-- <b-form-checkbox v-model="old">Генерация подробного протокола</b-form-checkbox> -->

			<b-form-group label="Соответствия ценообразующих факторов" :state="connections_state" invalid-feedback="Характеристика - первичный ключ не найден в перечислении соответствий">

				<b-form-row class="mb-2 d-flex h-100 m-0" no-gutters>

					<div class="select-connection d-flex" style="flex: 1;">
						<v-select :state="attr_xlsx_state" :clearable="false" v-model="attr_xlsx" :options="attrs_xlsx_visible" label="name" :reduce="obj => obj.id" clearSearchOnSelect required appendToBody/>
						<span class="text-center">-></span>
						<v-select :state="attr_state" :clearable="false" v-model="attr" label="name" :reduce="obj => obj.id" :options="attrs_visible" clearSearchOnSelect required appendToBody/>
					</div>

					<div align="right" class="d-flex ml-2" style="gap: .5rem;" >

						<b-button size="sm" variant="outline-primary" v-on:click="add_connection"><base-icon name="add" /></b-button>
						<b-button v-if="selected_connections.length" size="sm" variant="outline-danger" v-on:click="delete_connections"><base-icon name="delete" /></b-button>

					</div>

				</b-form-row>

				<b-table hover :items="this.connections" :fields="connections_fields" sort-by="date" selectable selected-variant="danger" v-on:row-selected="select_connection"/>

			</b-form-group>

		</b-overlay>

	</mymodal>

</template>

<script>

import XLSX from "xlsx"
import api from "../../../api"
import attrs from "../../../api/attrs"
import mymodal from "../../widgets/modal"

export default
{
	components :
	{
		mymodal,
	},

	data()
	{
		return {

			fl : null,
			fl_state : null,

			wb : { sheets : [] },

			sheet : null,
			sheet_state : null,

			attrs : [],
			attrs_xlsx : [],
			attrs_visible : [],
			attrs_xlsx_visible : [],
			attrs_for_primary_key : [],

			primary_attr : null,
			attr : null,
			attr_xlsx : null,

			primary_attr_state : null,
			attr_state : null,
			attr_xlsx_state : null,

			connections : [],
			connections_state : null,
			connections_fields : 
			[
				{
					key : "attr_xlsx",
					label : "Столбец",
					formatter : attr_xlsx => attr_xlsx.name
				},
				{
					key : "attr",
					label : "Ценообразующий фактор",
					formatter : attr => attr.name
				},
			],
			selected_connections : [],

			old : false,
			wait : false,

		}
	},

	methods :
	{
		reset()
		{
			const is_expensive = this.$parent.essence != "ОО" && this.$parent.essence != "ОА"
			const fixed_attr_primary_key = this.$parent.essence == "ОО" ? "attrs.CadastralNumber" : ( is_expensive ? "attrs.expensive_code" : "attrs.Name" )
			const is_test = api.is_test()
			var possible_attrs_keys = new Set([ "attrs.Segment", "attrs.Evaluating_Using_Code", "attrs.Type_Of_Using_Code" ])

			if(api.has_oks())
			{
				possible_attrs_keys.add("attrs.functional_group")
				possible_attrs_keys.add("attrs.functional_sub_group")
			}

			this.fl = null
			this.fl_state = null
			this.wb = { sheets : [] }
			this.sheet = null
			this.sheet_state = null
			this.attrs_xlsx = []
			this.attrs = api.deep_clone(this.$parent.attrs.filter(attr => attr.in_query && attr.key != "attrs.bad" && attr.key != "attrs.bad_profit" && attr.key != "attrs.bad_capitalization_rate" && ( is_expensive || attr.key == fixed_attr_primary_key || ( is_test || possible_attrs_keys.has(attr.key) ) ) ) )
			this.attrs_for_primary_key = api.deep_clone(this.$parent.attrs.filter(attr => ! attr.not_real && attr.key == fixed_attr_primary_key))
			this.attrs_xlsx_visible = []
			this.attrs_visible = []
			this.primary_attr_state = null
			this.attr_xlsx_state = null
			this.attr_state = null
			this.primary_attr = this.attrs_for_primary_key[0].id
			this.attr_xlsx = null
			this.attr = null
			this.connections = []
			this.connections_state = null
			this.selected_connections = []
			this.old = false
			this.wait = false

			this.refresh_visible_attrs()
		},

		check()
		{
			this.fl_state = !! this.fl
			this.sheet_state = !! this.sheet
			this.primary_attr_state = !! this.primary_attr
			this.connections_state = this.connections.find(elem => ( elem.attr.id == this.primary_attr )) != null

			return this.fl_state && this.sheet_state && this.primary_attr_state && this.connections_state
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		load_file(file)
		{
			if(file)
			{
				this.wb = { sheets : [] }
				this.sheet = null
				this.sheet_state = null
				this.attrs_xlsx = []
				this.attr_xlsx_state = null
				this.attr_xlsx = null
				this.connections = []
				this.connections_state = null

				if(file.name && file.name.endsWith(".xlsx"))
				{
					const reader = new FileReader()
				
					reader.onload =
						event =>
						{
							const raw = event.target.result
							
							this.wb = XLSX.read(raw, { type : "binary", sheetRows : 30 })

							if(this.wb.SheetNames.length)
								this.sheet_select(this.wb.SheetNames[0])

							this.wait = false

							this.set_all_attrs_to_visible()
						}

					this.wait = true

					reader.readAsBinaryString(file)
				}
				else
					this.$nextTick(() => { this.fl = null })
			}
		},

		sheet_select(sheet_name = null)
		{
			if(sheet_name != null)
				this.sheet = sheet_name

			this.attrs_xlsx = []
			this.attr_xlsx_state = null
			this.attr_xlsx = null
			this.connections = []
			this.connections_state = null

			const ws = this.wb.Sheets[this.sheet]
			const range = XLSX.utils.decode_range(ws["!ref"])

			for(var col = range.s.c; col <= range.e.c; col++)
			{
				var cell = ws[XLSX.utils.encode_cell({ c : col, r : 0 })]

				if(cell)
					this.attrs_xlsx.push({ name : cell.v, id : col + 1 })
			}
				
			this.set_all_attrs_to_visible()
			this.refresh_visible_attrs()
		},

		set_all_attrs_to_visible()
		{
			this.attrs.forEach(attr => { attr.visible = true })
			this.attrs_xlsx.forEach(attr => { attr.visible = true })
		},

		refresh_visible_attrs()
		{
			this.attrs_visible = this.attrs.filter(attr => attr.visible || attr.visible == null)
			this.attrs_xlsx_visible = this.attrs_xlsx.filter(attr => attr.visible || attr.visible == null)
		},

		add_connection()
		{
			this.attr_state = ( this.attr != null )
			this.attr_xlsx_state = ( this.attr_xlsx != null )

			if(! ( this.attr_xlsx_state && this.attr_state ) )
				return

			const attr_xlsx_ind = this.attrs_xlsx.findIndex(elem => elem.id == this.attr_xlsx)
			const attr_xlsx_name = this.attrs_xlsx[attr_xlsx_ind].name
			const attr_ind = this.attrs.findIndex(elem => elem.id == this.attr)
			const attr_id = this.attrs[attr_ind]

			this.attrs_xlsx[attr_xlsx_ind].visible = false
			this.attrs[attr_ind].visible = false
			this.refresh_visible_attrs()

			this.connections.push({ attr_xlsx : { name : attr_xlsx_name, id : this.attr_xlsx }, attr_xlsx_ind : attr_xlsx_ind, attr : attr_id, attr_ind : attr_ind })

			this.attr_xlsx = null
			this.attr = null
		},

		select_connection(selected)
		{
			this.selected_connections = selected
		},

		delete_connections()
		{
			this.selected_connections.forEach(
				selected_conn =>
				{
					const index = this.connections.findIndex(conn => conn.attr_ind == selected_conn.attr_ind)

					this.attrs_xlsx[selected_conn.attr_xlsx_ind].visible = true
					this.attrs[selected_conn.attr_ind].visible = true
					this.connections.splice(index, 1)
				})

			this.refresh_visible_attrs()
		},

		submit()
		{
			const reader = new FileReader()
			this.wait = true

			reader.onload =
				fl =>
				{
					api.upload_file(this, fl, this.fl.name, this.fl.name,
						response =>
						{
							var params = {

								file : response.id,
								sheet : this.sheet,
								query : this.$parent.get_query(),
								primary_attr : this.primary_attr,
								connections : [],
								new : ! this.old,

							}

							this.connections.forEach(elem => params.connections.push({ attr_xlsx : elem.attr_xlsx.id, attr : elem.attr.id }))
							this.wait = false

							api.call_long_operation(this, "Импорт ценообразующих факторов запущен", this.$parent.service, "import_attrs_from_xlsx", params,
								response =>
								{
									api.delete_file(this, params.file)
									api.open_response_url(response)

									this.$parent.wait = true

									attrs.load(this)
										.then(() => this.$parent.refresh_objects())
										// .then(() => this.$parent.filters_ready()) // 3907
										.then(() => { this.$parent.wait = false })
								},
								{ success_msg : "Импорт ценообразующих факторов завершен" }
							)
						})
				}
			
			reader.readAsBinaryString(this.fl)
		}
	}
}

</script>

<style scoped>
.select-connection .v-select
{
	width: calc(50% - 1.5rem / 2);
}

.select-connection span
{
	width: 1.5rem;
}
</style>

